<template>
  <div class="snail_anniversary_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'四周年纪念章'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="preloading preloading-snail"
        v-show="preloadingShow"
      ></div>
    </transition>

    <!-- 活动未开始 -->
    <div :class="'none ' + isWhite"></div>

    <div class="snail-anniversary-content">
      <div class="swiper-container " ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide slide-page-container">
            <div class="top-container">
              <div class="big-title"></div>
              <!-- 发售前文案：6月21日10:00正式开售！典藏版纪念奖章 限量666枚！   -->
              <div
                v-if="!canBuy && actual_quantity"
                class="right-title-1"
              ></div>
              <!-- 限量款售完前：全服抢购中！典藏版纪念奖章 限量666枚！ 也就是说还有限量款 -->
              <div
                v-if="
                  canBuy && actual_quantity && is_pay == 0
                "
                class="right-title-2"
              ></div>
              <!-- 限量款售完后：全服抢购中！四周年纪念奖章 有梗，有趣，还有蜗和鹂 -->
              <div
                v-if="
                  canBuy && !actual_quantity && is_pay == 0
                "
                class="right-title-3"
              ></div>
              <!-- 已购买普通款后：已购买 四周年纪念奖章 -->
              <div
                v-if="is_pay === 1 && userInfo.role_id"
                class="right-title-4"
              ></div>
              <!-- 已购买限量款后：已购买 典藏版纪念奖章 -->
              <div
                v-if="is_pay === 2 && userInfo.role_id"
                class="right-title-5"
              ></div>
              <div></div>
            </div>

            <div class="anniversary-swiper-box popup_wrap-box">
              <div class="swiper-container-2 " ref="mySwiper-2">
                <div class="swiper-wrapper">
                  <div
                    v-for="(item, index) in swiperList"
                    :key="index"
                    class="swiper-slide slide-page-1"
                  >
                    <div class="slide-box">
                      <img @click="showImage(item.photo)" :src="item.photo" />
                    </div>
                  </div>
                </div>
                <div
                  v-if="swiperList.length > 1"
                  class="swiper-pagination"
                ></div>
              </div>
              <div class="star_1"></div>
              <div class="star_2"></div>
              <div class="star_3"></div>
              <div class="tip_text" v-if="actual_quantity"></div>
            </div>

            <div class="role-container"></div>

            <div class="rule-box">
              <a
                href="javascript:;"
                class="rule-btn"
                @click="ruleShow = true"
              ></a>
            </div>
            <!-- 未登录 典藏版有库存 这个是三个的 -->
            <div
              v-if="!userInfo.role_id && actual_quantity"
              class="reward-container_3"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <div @click="openPayDialog(2)" class="right-box">
                  <i v-if="thirdNoClick"></i>
                </div>
                <div class="third-light"></div>
                <div class="third_star_1"></div>
                <div class="third_star_2"></div>
                <div class="light-bg"></div>
              </div>
            </div>
            <!-- 未登录 典藏版无库存 这个是两个的 -->
            <div
              v-if="!userInfo.role_id && !actual_quantity"
              class="reward-container_2"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>
              </div>
            </div>
            <!-- 已经登录 典藏款无库存未购买 -->
            <div
              v-if="userInfo.role_id && !actual_quantity && is_pay == 0"
              class="reward-container_2"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>
              </div>
            </div>

            <!-- 已经登录 典藏版有库存已经购买 -->
            <div
              v-if="userInfo.role_id && actual_quantity && is_pay == 2"
              class="reward-container_3"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <div @click="openPayDialog(2)" class="right-box">
                  <i v-if="thirdNoClick"></i>
                </div>
                <div class="third-light"></div>
                <div class="third_star_1"></div>
                <div class="third_star_2"></div>
                <div class="light-bg"></div>
              </div>
            </div>

            <!-- 已经登录 典藏版有库存未购买 -->
            <div
              v-if="userInfo.role_id && actual_quantity && is_pay == 0"
              class="reward-container_3"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <div @click="openPayDialog(2)" class="right-box">
                  <i v-if="thirdNoClick"></i>
                </div>
                <div class="third-light"></div>
                <div class="third_star_1"></div>
                <div class="third_star_2"></div>
                <div class="light-bg"></div>
              </div>
            </div>

            <!-- 已经登录 典藏版无库存购买典藏款 -->
            <div
              v-if="userInfo.role_id && !actual_quantity && is_pay == 2"
              class="reward-container_3"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <div @click="openPayDialog(2)" class="right-box">
                  <i v-if="thirdNoClick"></i>
                </div>
                <div class="third-light"></div>
                <div class="third_star_1"></div>
                <div class="third_star_2"></div>
                <div class="light-bg"></div>
              </div>
            </div>

            <!-- 没库存买了周年款 -->
            <div
              v-if="userInfo.role_id && !actual_quantity && is_pay == 1"
              class="reward-container_2"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>
              </div>
            </div>
            <!-- 典藏有库存但已经购买周年款 -->
            <div
              v-if="userInfo.role_id && actual_quantity && is_pay == 1"
              class="reward-container_3"
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <div @click="openPayDialog(2)" class="right-box">
                  <i v-if="thirdNoClick"></i>
                </div>
                <div class="third-light"></div>
                <div class="third_star_1"></div>
                <div class="third_star_2"></div>
                <div class="light-bg"></div>
              </div>
            </div>

            <!-- 未登录 典藏版有库存 这个是三个的 -->
            <div
              class="btn-box"
              v-if="
                (!userInfo.role_id && actual_quantity) ||
                  (userInfo.role_id && actual_quantity && is_pay == 0)
              "
            >
              <div class="top-box">
                <!-- 福利礼包 -->
                <a
                  v-if="canBuy"
                  @click="openPayDialog(3)"
                  class="welfare-btn"
                  href="javascript:;"
                >
                  <i v-if="firstNoClick"></i
                ></a>
                <div class="no_time-container" v-else>
                  <a
                    @click="openPayDialog(3)"
                    class="not_time_btn-uni"
                    href="javascript:;"
                  ></a>
                  <p class="bottom-text">
                    福利礼包还剩{{ compCountdown }}解锁！
                  </p>
                </div>

                <!-- 周年款 -->
                <a
                  @click="openPayDialog(1)"
                  class="anniversary-btn"
                  href="javascript:;"
                >
                  <i v-if="secondNoClick"></i
                ></a>
                <!-- 典藏款 -->
                <a
                  @click="openPayDialog(2)"
                  class="collection-btn"
                  href="javascript:;"
                >
                  <i v-if="thirdNoClick"></i
                ></a>
              </div>
            </div>

            <!-- 未登录 典藏版无库存 这个是两个的 -->
            <div
              class="btn-box"
              v-if="
                (!userInfo.role_id && !actual_quantity) ||
                  (userInfo.role_id && !actual_quantity && is_pay == 0)
              "
            >
              <div class="top-box">
                <!-- 福利礼包 -->
                <a
                  v-if="canBuy"
                  @click="openPayDialog(3)"
                  class="welfare-btn-no"
                  href="javascript:;"
                >
                  <i v-if="firstNoClick"></i>
                </a>
                <div class="no_time-container" v-else>
                  <a
                    @click="openPayDialog(3)"
                    class="not_time_btn-no"
                    href="javascript:;"
                  ></a>
                  <p class="bottom-text-no">
                    福利礼包还剩{{ compCountdown }}解锁！
                  </p>
                </div>
                <!-- 周年款 -->
                <a
                  @click="openPayDialog(1)"
                  class="anniversary-btn-no"
                  href="javascript:;"
                >
                  <i v-if="secondNoClick"></i
                ></a>
              </div>
            </div>

            <!-- 购买了典藏款  显示三个礼包 福利按钮+收件按钮 或者  买了周年款 典藏款还没卖完 -->
            <div
              class="btn-box"
              v-if="
                (userInfo.role_id && actual_quantity && is_pay == 1) ||
                  (userInfo.role_id && !actual_quantity && is_pay == 2) ||
                  (userInfo.role_id && actual_quantity && is_pay == 2) ||
                  (userInfo.role_id && !actual_quantity && is_pay == 1)
              "
            >
              <div class="top-box">
                <!-- 福利礼包 -->
                <a
                  v-if="canBuy"
                  @click="openPayDialog(3)"
                  class="welfare-btn-uni"
                  href="javascript:;"
                >
                  <i v-if="firstNoClick"></i
                ></a>
                <div class="no_time-container" v-else>
                  <a
                    @click="openPayDialog(3)"
                    class="not_time_btn"
                    href="javascript:;"
                  ></a>
                  <p class="bottom-text">
                    福利礼包还剩{{ compCountdown }}解锁！
                  </p>
                </div>

                <a
                  class="address-btn-anniversary"
                  href="javascript:;"
                  @click="openAddress"
                ></a>
                <!-- <a class="address-btn-collection" href="javascript:;" @click="addressShow = true"></a> -->
              </div>
            </div>

            <div class="bottom-item"></div>
          </div>

          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>
    </div>

    <Header :isOnline="1" :config="headerConfig" />
    <!-- <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" /> -->
    <!-- 所有弹窗 -->
    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :loginTypes="loginTypes"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"
      noAuthLogin
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    ></Os>

    <!-- 规则弹窗 -->
    <div
      :class="'rule-wrap popup_wrap rule-wrap-' + ruleShow"
      v-show="ruleShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="rule-box popup_wrap-box" v-show="ruleShow">
          <div class="rule_text_out">
          <img class="rule_text" :src="ruleSrc" /></div>
        </div>
      </transition>
      <div class="close-bg" @click="ruleShow = false"></div>
    </div>

    <!-- 贵重品弹窗 -->
    <div
      :class="'expensive-wrap popup_wrap expensive-wrap-' + expensiveShow"
      v-show="expensiveShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="expensive-box popup_wrap-box" v-show="expensiveShow"></div>
      </transition>
      <div class="close-bg" @click="expensiveShow = false"></div>
    </div>

    <!-- 图片预览弹窗 -->
    <div
      :class="'preview-wrap preview-wrap-' + previewShow"
      v-show="previewShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="preview-box" v-show="previewShow">
          <img :src="nowImg" />
        </div>
      </transition>
      <div class="close-bg" @click="previewShow = false"></div>
    </div>

    <!-- 福利礼包弹窗 -->
    <div
      :class="'welfare-wrap popup_wrap welfare-wrap-' + welfareShow"
      v-show="welfareShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="welfare-box popup_wrap-box" v-show="welfareShow">
          <div class="get-btn-box">
            <a
              @click="getReward"
              v-if="!canBuy || !reawrd_status"
              class="get-btn"
              href="javascript:;"
            ></a>
            <a
              @click="reReward"
              v-if="canBuy && reawrd_status"
              class="not-get-btn"
              href="javascript:;"
            ></a>
          </div>
          <div class="reward-list-wrapper">
            <div class="list-content">
              <div
                :class="`list-item ${i}`"
                v-for="(i, index) in welfareStyle"
                :key="index"
              ></div>
            </div>
          </div>
          <div v-if="!canBuy" class="end-tip-text">
            <p>福利礼包还剩{{ compCountdown }}解锁！</p>
          </div>
        </div>
      </transition>

      <div class="close-bg" @click="welfareShow = false"></div>
    </div>

    <!-- 购买纪念章弹窗 -->
    <div
      :class="
        'anniversary-wrap popup_wrap aniniversary-wrap-' + buyAnniversaryShow
      "
      v-show="buyAnniversaryShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="anniversary-box popup_wrap-box" v-show="buyAnniversaryShow">
          <div
            :class="[
              buyType === 1 ? 'first-anniversary' : '',
              buyType === 2 ? 'second-anniversary' : '',
              buyType === 3 ? 'third-anniversary' : '',
              buyType === 4 ? 'four-anniversary' : ''
            ]"
          ></div>
          <div class="anniversary-item">
            <div
              :class="[
                buyType === 1 || buyType === 3 ? 'first-desc' : '',
                buyType === 2 || buyType === 4 ? 'second-desc' : ''
              ]"
            ></div>
          </div>
          <!-- 奖励列表预览 -->
          <div class="reward-list-wrapper">
            <div class="list-content-wrapper">
              <div class="list-content">
                <div
                  @click="isExpensiveItem(i)"
                  :class="['list-item', `${i}`]"
                  v-for="(i, index) in rewardShowList"
                  :key="index"
                ></div>
              </div>
            </div>
          </div>
          <!-- 付费购买周年/典藏礼包后，再次点击礼包，依然出现奖励介绍弹窗，但此时不出现支付按钮，顶部标题文案变为“周年版/典藏版纪念章” -->
          <div v-if="is_pay === 0 && canBuy" class="bottom-container">
            <div class="bottom-box">
              <div @click="goToPay('wechat')" class="wechat-btn"></div>
              <div @click="goToPay('alipay')" class="zfb-btn"></div>
            </div>
          </div>
          <div v-if="canBuy" class="quality-text"></div>
          <div v-if="!canBuy" class="end-tip-text">
            <p>奖章礼包还剩{{ compCountdown }}解锁！</p>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="closeAnniversary"></div>
    </div>

    <!-- 典藏款地址信息弹窗 -->
    <div class="dck-address-wrap popup_wrap" v-show="dckAddressShow">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="address-box popup_wrap-box" v-show="dckAddressShow">
          <div class="name_class">
            <input type="text" v-model.trim="name" :disabled="end_address" />
          </div>
          <div class="phone_class">
            <input type="text" v-model.trim="phone" :disabled="end_address" />
          </div>
          <div class="address_class">
            <textarea
              type="text"
              v-model.trim="address"
              :disabled="end_address"
            />
          </div>
          <div class="delivery_class">
            <input
              disabled
              v-if="odd_number"
              type="text"
              v-model="odd_number"
            />
            <input disabled v-else type="text" v-model="no_add_number" />
          </div>
          <div
            id="odd_number"
            @click="onCopy('#odd_number')"
            :data-clipboard-text="odd_number"
            class="clipboard_class"
          ></div>
          <!-- 单号存在 或者禁止填写了 隐藏掉 -->
          <div
            v-if="!end_address"
            class="affirm"
            @click="registerSuccess"
          ></div>
          <div class="close-bg" @click="closeDck"></div>
        </div>
      </transition>
    </div>

    <!-- 周年款地址信息弹窗 -->
    <div class="znk-address-wrap popup_wrap" v-show="znkAddressShow">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="address-box popup_wrap-box" v-show="znkAddressShow">
          <div class="name_class">
            <input type="text" v-model.trim="name" :disabled="end_address" />
          </div>
          <div class="phone_class">
            <input type="text" v-model.trim="phone" :disabled="end_address" />
          </div>
          <div class="address_class">
            <textarea
              type="text"
              v-model.trim="address"
              :disabled="end_address"
            />
          </div>
          <div class="delivery_class">
            <input
              disabled
              v-if="odd_number"
              type="text"
              v-model="odd_number"
            />
            <input disabled v-else type="text" v-model="no_add_number" />
          </div>
          <div
            id="odd_number"
            @click="onCopy('#odd_number')"
            :data-clipboard-text="odd_number"
            class="clipboard_class"
          ></div>
          <!-- 单号存在 或者禁止填写了 隐藏掉 -->
          <div
            v-if="!end_address"
            class="affirm"
            @click="registerSuccess"
          ></div>
          <div class="close-bg" @click="closeZnk"></div>
        </div>
      </transition>
    </div>

    <!-- 支付提示-弹窗 -->
    <div class="payment_tips_page popup_wrap" v-show="paymentTipsShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="payment_tips_box" v-show="paymentTipsShow">
          <h2>提示</h2>
          <p>请确认是否完成支付</p>
          <div>
            <a @click="orderQuery(1)" href="javascript:;">已完成支付</a>
            <a @click="orderQuery(2)" href="javascript:;">未完成支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 上一笔订单未支付提示-弹窗 -->
    <div class="payment_tips_page popup_wrap" v-show="fePaymentTipsShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="payment_tips_box" v-show="fePaymentTipsShow">
          <h2>提示</h2>
          <p>您有一笔订单是否继续支付</p>
          <div>
            <a @click="cancelOrder" href="javascript:;">关闭取消支付</a>
            <a @click="goOnPay" href="javascript:;">继续前往支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 付款失败-弹窗 -->
    <div class="payment-failed-wrap popup_wrap" v-show="paymentFailedShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="popup-wrap-box" v-show="paymentFailedShow">
          <div class="btn-box-sure">
            <a href="javascript:;" @click="payFail">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="clonePayment()"></div>
    </div>

    <!-- 微信里的支付宝引导 -->
    <div class="wx_download_wrap popup_wrap" v-show="zfbShow">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }"
      >
        <div class="wx_download_wrap_content" @click="zfbShow = false"></div>
      </transition>
      <div class="close-bg" v-if="zfbShow" @click="zfbShow = false"></div>
    </div>

    <div class="content-01" :style="'visibility: ' + showVideo">
      <canvas id="canvas" width="100%" height="100%"></canvas>
    </div>

    <!-- 支付宝调用标签 -->
    <div id="aliPayBtn"></div>

    <!-- 阻止点击弹出-弹窗 -->
    <div
      @touchmove.prevent
      :class="'prevent-wrap prevent-wrap-' + preventShow"
    ></div>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import { swiper } from "vue-awesome-swiper";
import Clipboard from "clipboard";
import {
  hasActualQuality,
  onGetInitDataAPI,
  getRewardApi,
  modifyAddressApi,
  craeteOrderApi,
  checkOrderAPI,
  wechatInfoAPI,
  orderOff
} from "../api";
import { getTimeStamp, wechatBrowser, buriedLogger, getRandomString } from "@/utils/utils";
import "../jsmpeg";

const commonConfig = {
  resistanceRatio: 0,
  mousewheelControl: true,
  speed: 500,
  parallax: true,
  slidesPerView: "auto",
  lazyLoading: true,
  lazyLoadingInPrevNext: true,
  preloadImages: false,
  observer: true,
  observeParents: true
};
export default {
  name: "anniversary",
  components: {
    swiper,
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      showVideo: "hidden",
      isWhite: "",
      forbbiden: false,
      protocol: "",
      host: "",
      ruleSrc:"https://download4.qcplay.com/snail/four-anniversary/popup/rule_text.png",
      swiperList: [
        {
          photo: "https://download4.qcplay.com/snail/four-anniversary/anniversary.png"
        },
        {
          photo: "https://download4.qcplay.com/snail/four-anniversary/slide2.png"
        }
      ],
      reawrd_status: false, // 未领取过
      end_address: false, // 是否结束填写地址
      old_order: null, // 未支付的订单
      rewardShowList: [], // 弹窗展示的奖励
      zfbShow: false,
      no_add_number: "未发货",
      odd_number: "",
      deliveryNumber: null, // 快递单号
      // 提交信息的数据
      name: "", // 联系人
      phone: "", // 手机号
      address: "", // 收货地址
      is_pay: 0, // 0: 还没买 1: 周年款 2: 典藏款
      firstNoClick: true, // 默认玩家没点击过第一个礼包的
      secondNoClick: true, // 默认玩家没点击过第二个礼包的
      thirdNoClick: true, // 默认玩家没点击过第三个礼包的
      welfareShow: false,
      canBuy: true, // 是否发售
      timer: null, // 定时器
      compCountdown: "",
      countdown: "",
      buyType: "", // 购买的是哪一个  1: 周年款 2: 典藏款 3: 普通福利
      collectionStyle: ["dck-gzp", "avatar-a", "bkd-1000", "cjq-20", "jnz-50"], // 典藏款
      anniversaryStyle: ["znk-gzp", "avatar-b", "bkd-600", "cjq-10", "jnz-30"], // 周年款
      welfareStyle: ["bkd-300", "cjq-5", "jnz-10"],
      nowImg: "", // 当前预览的是哪一张图
      buyAnniversaryShow: false, // 纪念窗弹窗
      expensiveShow: false, // 贵重品弹窗
      previewShow: false, // 预览图片弹窗
      dckAddressShow: false, // 典藏款地址信息弹窗
      znkAddressShow: false, // 周年款地址信息弹窗
      count: 2,
      headerConfig,
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: "http://snail.qingcigame.com/official/",
      taptapUrl: "https://tap.cn/tm3lTYBt?channel=rep-rep_nlo5ha7ptsr",
      preloadingShow: false,
      preventShow: false,
      noSign: true,
      ruleShow: false,
      actual_quantity: false, // 是否还有典藏款
      paymentTipsShow: false,
      fePaymentTipsShow: false, // 上一笔没支付成功
      isWechatBrowser: false, // 是否为微信浏览器
      // 支付选择类型
      my_payment_select: 0, // 0支付宝  1是微信
      // 当前支付类型
      paymentData: "",
      // open_id微信支付用
      open_id: "",
      // 2种支付方式
      paymentList: [
        {
          icon: "zfb",
          name: "支付宝支付",
          select: "1",
          payType: "alipay",
          payMethod: "wap"
        },
        {
          icon: "wx",
          name: "微信支付",
          select: "0",
          payType: "wechat",
          payMethod: "mp"
        }
      ],
      // 单独微信支付方式
      paymentList3: [
        {
          icon: "wx",
          name: "微信支付",
          select: "1",
          payType: "wechat",
          payMethod: "mp"
        }
      ],
      paymentSuccessShow: false, // 支付成功 弹窗
      paymentFailedShow: false, // 支付失败 弹窗
      payFailMessage: "当前有一笔订单正在支付中，请稍后重试..." // 支付失败 错误信息
    };
  },
  created() {
    window.addEventListener('pageshow', this.resize)
    window.addEventListener('resize', this.resize)
    this.isWechatBrowser = wechatBrowser();
    hasActualQuality().then(response => {
      if (Number(response.code) === 200) {
        this.actual_quantity = response.data.actual_quantity;
      } else {
        this.onToast(response.message);
      }
    });
    // 微信app内，需要获取openid才能做微信支付
    if (this.isWechatBrowser) {
      wechatInfoAPI().then(response => {
        if (Number(response.code) === 200) {
          this.open_id = response.data.open_id;
          if (response.data.open_id == null) {
            window.location.href =
              "//api.qingcigame.com/wechat/get/open/?back=" +
              encodeURIComponent(window.location.href);
            return;
          }
          this.getLoginContainer();
        } else {
          this.getLoginContainer();
          this.onToast(response.message);
        }
      });
    }
    this.getLoginContainer();
  },
  mounted() {
    this.$nextTick(() => {
      const { protocol, host } = window.location;
      const enterLink = `${protocol}//${host}/snail/four-anniversary/enter${getRandomString()}`;
      const pcLink = `${protocol}//${host}/snail/four-anniversary/pc`;
      this.monitoringEquipmentPc(pcLink);
      this.isSetShare(enterLink);
      console.log('ppp', pcLink)

      this.anniverSarySwiper(); // 首页初始化
      this.hlwSwiper2(); // 纪念章轮播初始化
      // 埋点
      const bl = buriedLogger("snail", "蜗牛_四周年_纪念章h5");
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum("蜗牛_四周年_纪念章h5_活动页统计");
      }, 200);
      
    });
  },
  methods: {
    monitoringEquipmentPc(pcLink) {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = pcLink;
      console.log('ppp', pcLink)
    },
    resize() {
      // 兼容宽屏
      if (window.innerWidth / window.innerHeight > 320 / 470) {
        document.querySelectorAll('.popup_wrap .popup_wrap-box').forEach(item => {
          item.style.transform = 'scale(0.75)'
        })
      } else if (window.innerWidth / window.innerHeight > 320 / 520) {
        document.querySelectorAll('.popup_wrap .popup_wrap-box').forEach(item => {
          item.style.transform = 'scale(0.85)'
        })
      } else if (window.innerWidth / window.innerHeight > 320 / 560) {
        document.querySelectorAll('.popup_wrap .popup_wrap-box').forEach(item => {
          item.style.transform = 'scale(0.9)'
        })
      } else if (window.innerWidth / window.innerHeight > 320 / 620) {
        document.querySelectorAll('.popup_wrap .popup_wrap-box').forEach(item => {
          item.style.transform = 'scale(0.95)'
        })
      }
    },
    video() {
      let canvas = document.getElementById("canvas");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      let url = "https://download4.qcplay.com/snail_four/video/0619.ts";
      let player = new window.$JSMpeg.Player(url, {
        canvas: canvas,
        loop: false,
        autoplay: true,
        audio: false,
        progressive: false,
        onSourceCompleted: player => {
          this.showVideo = "visible";
          this.preloadingShow = false;
        },
        onEnded: player => {
          this.showVideo = "hidden";
          localStorage.setItem("lookedVideo", 1);
        }
      });
      player.play();
    },
    closeDck() {
      this.dckAddressShow = false;
    },
    closeZnk() {
      this.znkAddressShow = false;
    },
    openAddress() {
      this.getLoginContainer();
      if (this.is_pay == 1) {
        // 买了周年款
        this.znkAddressShow = true;
      } else {
        this.dckAddressShow = true;
      }
      this.logger.sum("蜗牛_四周年_纪念章h5_点击收货地址按钮");
    },
    payFail() {
      this.paymentFailedShow = false;
      this.getLoginContainer();
      this.logger.sum("蜗牛_四周年_纪念章h5_点击支付失败的确定按钮");
    },
    cancelOrder() {
      orderOff()
        .then(response => {
          if (Number(response.code) === 200) {
            this.fePaymentTipsShow = false;
            this.getLoginContainer();
          }
          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
      this.logger.sum("蜗牛_四周年_纪念章h5_取消支付按钮");
    },
    reReward() {
      this.onToast("很抱歉,您已经领取过");
    },
    goOnPay() {
      window.location.href = this.old_order;
      setTimeout(() => {
        this.preventShow = false;
      }, 1000);
      this.logger.sum("蜗牛_四周年_纪念章h5_点击支付上一笔订单的按钮");
    },
    monitoringEquipment() {
      if (
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      ) {
        this.paymentList = this.paymentList3;
      }
    },
    // 立即支付
    goToPay(payType) {
      // 微信内的支付宝支付还是让他跑外面去付
      // 微信内的微信支付一直都是最新的 支付宝的话会弹出引导
      // // 监测是否微信 (是为mp，否则map)
      if (this.paymentList.length > 1) {
        if (
          navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
          "micromessenger"
        ) {
          this.paymentList[1].payMethod = "mp";
        } else {
          this.paymentList[1].payMethod = "wap";
        }
      }
      if (this.isWechatBrowser && payType == "alipay") {
        // 在微信app下点的是支付宝支付
        this.preventShow = false;
        this.zfbShow = true;
        return;
      }
      var type;
      if (this.buyType === 1 || this.buyType === 3) {
        type = 0;
      } else {
        type = 1;
      }
      // 0 是支付宝 1是微信
      if (this.paymentList.length > 1) {
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
          "micromessenger";
        payType == "wechat"
          ? (this.my_payment_select = 1)
          : (this.my_payment_select = 0);
        for (var i = 0; i <= this.paymentList.length - 1; i++)
          this.paymentList[i].select = 0;
        this.paymentList[this.my_payment_select].select = 1;
        this.paymentData = this.paymentList[this.my_payment_select];
      } else {
        // 微信内只有一种
        this.paymentData = this.paymentList3[0];
      }
      this.preventShow = true;
      // 微信外的支付
      if (!this.isWechatBrowser && this.old_order) {
        this.fePaymentTipsShow = true;
        setTimeout(() => {
          this.preventShow = false;
        }, 500);
        return;
      }
      craeteOrderApi({
        pay_type: this.paymentData.payType,
        pay_method: this.paymentData.payMethod,
        open_id: this.open_id,
        type
      }).then(response => {
        if (response.message == "很抱歉,典藏款已被抢完~") {
          this.onToast(response.message, 2000);
          this.buyAnniversaryShow = false;
          this.getLoginContainer(); // 初始化一次
          setTimeout(() => {
            this.preventShow = false;
          }, 500);
          return;
        }
        if (Number(response.code) == 200) {
          // 只有支付宝支付才要判断
          // 微信内的微信内支付没有
          // 微信内的支付宝支付还是让他跑外面去付
          // 支付订单存储
          this.order = response.data.order;
          this.paymentTipsShow = true;
          // 移动端
          if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            // 微信发送支付
            if (this.paymentData.payType == "wechat") {
              // 外部浏览器调用
              if (this.paymentData.payMethod == "mp") {
                // wx.ready(() => {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                  nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: response.data.data.paySign, // 支付签名
                  success: function(res) {
                    // 支付成功后的回调函数
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  },
                  fail: function(res) {
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  }
                });
                // })
                setTimeout(() => {
                  this.preventShow = false;
                }, 2000);
              } else {
                if (response.data.data !== "") {
                  window.location.href = response.data.data;
                  setTimeout(() => {
                    this.preventShow = false;
                  }, 1000);
                }
              }
            } else if (response.data.data !== "") {
              // document.getElementById("aliPayBtn").innerHTML =
              //   response.data.data;
              // document.forms["alipaysubmit"].submit();
              window.location.href = response.data.data;
              setTimeout(() => {
                this.preventShow = false;
              }, 1000);
            }
          }
          return;
        }
        this.onToast(response.message, 2000);
        setTimeout(() => {
          this.preventShow = false;
        }, 500);
        this.logger.sum("蜗牛_四周年_纪念章h5_点击购买按钮");
      });
    },
    timeFormatted(str) {
      // 计算小时
      const hours = Math.floor(str / 3600);
      // 计算分钟
      const minutes = Math.floor((str % 3600) / 60);
      // 计算秒
      const seconds = str % 60;
      // 格式化为 h:m:s，确保每个单位至少有两位数字
      return `${hours}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
    // 复制
    onCopy(my_id) {
      const clipboard = new Clipboard(my_id);
      clipboard.on("success", e => {
        this.onToast("复制成功", 1000);
        e.clearSelection();
      });
      clipboard.on("error", e => {
        this.onToast("复制失败", 1000);
      });
    },
    orderQuery(type) {
      this.paymentTipsShow = false;
      // 订单轮询
      type == 1 ? (this.wait = 15) : (this.wait = 2);
      this.orderLoop(type);
      this.logger.sum(`订单轮询_${type === 1 ? "已完成订单" : "未完成订单"}`);
    },
    // 订单轮询
    orderLoop(i) {
      if (this.wait > 0) {
        this.onPayment(i);
        this.wait--;
        this.preventShow = true;
        Indicator.open();
        setTimeout(() => {
          this.orderLoop(i);
        }, 1500);
      } else {
        this.preventShow = false;
      }
    },
    onPayment(i) {
      checkOrderAPI({ trade_no: this.order }).then(response => {
        if (Number(response.code) === 200) {
          // 支付成功
          this.wait = 0;
          if (i == 1) this.onToast(response.message, 2000);
          this.getSuccessPayContainer();
          this.buyAnniversaryShow = false;
          this.preventShow = false;
          Indicator.close();
          return;
        }
        if (Number(response.code) != 200) {
          if (this.wait == 0) {
            if (i == 1) this.onToast(response.message, 2000);
            this.paymentFailedShow = true;
            Indicator.close();
          }
        }
      });
    },
    openPopup(name) {
      this[name] = true;
    },
    closeAnniversary() {
      this.payWay = 0;
      this.buyAnniversaryShow = false;
    },
    // 登记信息提交按钮
    registerSuccess() {
      this.submitInfo();
    },
    // 提交信息接口请求
    submitInfo() {
      const filterSpaces = str => {
        return str.replace(/\s/g, "");
      };
      // 如果已经发货的提示也不请求了
      if (this.odd_number !== 0) {
        this.onToast("已成功发货，可复制单号查询物流！");
        return;
      }
      let params = {
        name: filterSpaces(this.name),
        phone: filterSpaces(this.phone),
        address: filterSpaces(this.address)
      };
      modifyAddressApi(params).then(res => {
        if (res.code === 200) {
          // this.isWriteShow = false
          // this.isSuccessShow = true
          // // 成功后调用初始化数据
          // this.initData()
          this.getLoginContainer();
          this.znkAddressShow = false;
          this.dckAddressShow = false;
          this.onToast(res.message);
        } else {
          if (res.message == "很抱歉,请求参数不正确") {
            this.onToast("尚未完成地址填写");
            return;
          }
          this.onToast(res.message);
        }
        this.logger.sum("蜗牛_四周年_纪念章h5_点击确认收货地址的按钮");
      });
    },
    // 领取福利礼包
    getReward() {
      if (!this.canBuy) {
        this.onToast("还未到领取时间");
        return;
      }
      getRewardApi()
        .then(response => {
          if (Number(response.code) === 200) {
            this.welfareShow = false;
            this.getLoginContainer();
            this.logger.sum("蜗牛_四周年_纪念章h5_点击领取福利礼包的按钮");
          }
          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
    },
    // 判断是不是贵重品
    isExpensiveItem(itemName) {
      if (itemName === "dck-gzp" || itemName === "znk-gzp") {
        this.expensiveShow = true;
        this.logger.sum("蜗牛_四周年_纪念章h5_点击贵重品");
      } else {
        return;
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          // 每次减少1秒
          this.countdown--;
          this.compCountdown = this.timeFormatted(this.countdown);
        } else {
          // 倒计时结束，清除定时器
          this.canBuy = true;
          clearInterval(this.timer);
        }
      }, 1000); // 每1000毫秒更新一次
    },
    showImage(src) {
      this.nowImg = src;
      this.previewShow = true;
      this.logger.sum("蜗牛_四周年_纪念章h5_点击查看大图");
    },
    openPayDialog(buyType) {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      if (buyType === 1) {
        // 周年
        window.localStorage.setItem(
          `${this.user_info.role_name}` + "_secondClick",
          false
        );
        this.secondNoClick = false;
        this.buyType = buyType;
        this.buyAnniversaryShow = true;
        this.rewardShowList = this.anniversaryStyle;
      } else if (buyType === 2) {
        // 典藏
        window.localStorage.setItem(
          `${this.user_info.role_name}` + "_thirdClick",
          false
        );
        this.buyType = buyType;
        this.thirdNoClick = false;
        this.buyAnniversaryShow = true;
        this.rewardShowList = this.collectionStyle;
      } else {
        window.localStorage.setItem(
          `${this.user_info.role_name}` + "_firstClick",
          false
        );
        // 福利礼包
        this.firstNoClick = false;
        this.welfareShow = true;
      }
      // 买过了
      if (this.is_pay) {
        if (this.buyType === 1) {
          this.buyType = 3;
        } else {
          this.buyType = 4;
        }
      }
      this.logger.sum("蜗牛_四周年_纪念章h5_查看对应礼包的按钮");
    },
    // 初始化swiper
    anniverSarySwiper() {
      new Swiper(".swiper-container", {
        ...commonConfig,
        direction: "vertical"
      });
    },
    hlwSwiper2() {
      new Swiper(".swiper-container-2", {
        ...commonConfig,
        spaceBetween: 100,
        pagination: ".swiper-pagination"
      });
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "最强蜗牛四周年纪念奖牌",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/AWhrzpeZARczrjaEKOrwo431bnHP4ZHCOy6zr0QP.png",
        desc: "最强蜗牛四周年限定纪念奖牌来袭！疯狂四周年，陪你一百年！"
      });
    },
    // 获取用户信息
    getSuccessPayContainer() {
      onGetInitDataAPI()
        .then(response => {
          this.isWhite = Number(response.code) !== 403;
          if (Number(response.code) === 200) {
            this.active_Info = response.data.activity || [];
            this.user_info = response.data.user_info || [];
            this.actual_quantity = response.data.activity.actual_quantity; // 是否还有典藏款
            this.odd_number = response.data.activity.odd_number; // 是否发货了
            this.is_pay = response.data.activity.is_pay; // 是否购买了 0 1 2
            this.name = response.data.activity.name;
            this.phone = response.data.activity.phone;
            this.address = response.data.activity.address;
            this.countdown = response.data.activity.countdown;
            this.end_address = response.data.activity.end_address;
            this.reawrd_status = response.data.activity.reawrd_status;
            this.old_order = response.data.activity.old_order;
            this.compCountdown = this.timeFormatted(this.countdown);
            this.startCountdown();
            this.onInitDataCallback(response);
            if (this.countdown > 0) {
              this.canBuy = false;
            }
            if (this.is_pay == 1) {
              // 买了周年款
              this.znkAddressShow = true;
            } else if (this.is_pay == 2) {
              this.dckAddressShow = true;
            }
            return;
          }
          Number(response.code) !== 401 && this.onToast(response.message);
        })
        .catch(err => {
          this.onToast("服务器出错啦");
        });
    },
    async getLoginContainer() {
      if (localStorage.getItem("lookedVideo")) {
        setTimeout(() => {
          this.preloadingShow = false;
        }, 1000);
      } else {
        this.preloadingShow = true
      }
      await onGetInitDataAPI()
        .then(response => {
          this.isWhite = Number(response.code) !== 403;
          if (Number(response.code) != 403) {
            setTimeout(() => {
              if (localStorage.getItem("lookedVideo")) {
                // 看过视频了就直接进入
                this.showVideo = "hidden";
              } else {
                // 没看过视频
                this.$nextTick(() => {
                  this.video();
                });
              }
            }, 1001);
          }
          if (Number(response.code) === 200) {
            this.active_Info = response.data.activity || [];
            this.user_info = response.data.user_info || [];
            this.actual_quantity = response.data.activity.actual_quantity; // 是否还有典藏款
            this.odd_number = response.data.activity.odd_number; // 是否发货了
            this.is_pay = response.data.activity.is_pay; // 是否购买了 0 1 2
            this.name = response.data.activity.name;
            this.phone = response.data.activity.phone;
            this.address = response.data.activity.address;
            this.countdown = response.data.activity.countdown;
            this.end_address = response.data.activity.end_address;
            this.reawrd_status = response.data.activity.reawrd_status;
            this.old_order = response.data.activity.old_order;
            if (this.countdown > 0) {
              this.canBuy = false;
            }
            this.compCountdown = this.timeFormatted(this.countdown);
            if (this.timer) clearInterval(this.timer);
            this.startCountdown();
            this.onInitDataCallback(response);
            return;
          }
          Number(response.code) !== 401 && this.onToast(response.message);
        })
        .catch(err => {
          this.onToast("服务器出错啦");
        });
      setTimeout(() => {
        this.preloadingShow = false;
      }, 5000)
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.active_Info = [];
      this.user_info = [];
      this.firstNoClick = true;
      this.secondNoClick = true;
      this.thirdNoClick = true;
      this.odd_number = "";
      this.actual_quantity = true;
      this.is_pay = 0;
      this.canBuy = true;
      if (this.timer) {
        clearInterval(this.timer);
      }
      hasActualQuality().then(response => {
        if (Number(response.code) === 200) {
          this.actual_quantity = response.data.actual_quantity;
        } else {
          this.onToast(response.message);
        }
      });
      this.getLoginContainer();
    },
    // 选择角色后
    selectCallback() {
      onGetInitDataAPI().then(response => {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.onInitDataCallback(response);
        this.firstNoClick = this.userInfo.role_name
          ? JSON.parse(
              window.localStorage.getItem(
                `${this.userInfo.role_name}` + "_firstClick"
              )
            )
          : true;
        this.secondNoClick = this.userInfo.role_name
          ? JSON.parse(
              window.localStorage.getItem(
                `${this.userInfo.role_name}` + "_secondClick"
              )
            )
          : true;
        this.thirdNoClick = this.userInfo.role_name
          ? JSON.parse(
              window.localStorage.getItem(
                `${this.userInfo.role_name}` + "_thirdClick"
              )
            )
          : true;
      });
    },
    // TAG: 相关业务方法
    //   onInvite() {
    //     if (this.userInfo.role_id === undefined) {
    //       this.changeLoginPopup(true);
    //       return false;
    //     }
    //   },
    // 注销
    osCancell() {
      this.clearActiveInfo();
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          console.log("注销的时候");
          this.osCancell();
        } else if (
          newValue.role_id !== oldValue.role_id ||
          newValue.account !== oldValue.account
        ) {
          this.firstNoClick = window.localStorage.getItem(
            `${this.userInfo.role_name}` + "_firstClick"
          )
            ? JSON.parse(
                window.localStorage.getItem(
                  `${this.userInfo.role_name}` + "_firstClick"
                )
              )
            : true;
          this.secondNoClick = window.localStorage.getItem(
            `${this.userInfo.role_name}` + "_secondClick"
          )
            ? JSON.parse(
                window.localStorage.getItem(
                  `${this.userInfo.role_name}` + "_secondClick"
                )
              )
            : true;
          this.thirdNoClick = window.localStorage.getItem(
            `${this.userInfo.role_name}` + "_thirdClick"
          )
            ? JSON.parse(
                window.localStorage.getItem(
                  `${this.userInfo.role_name}` + "_thirdClick"
                )
              )
            : true;
          // 数据初始化
          this.getLoginContainer();
          hasActualQuality().then(response => {
            if (Number(response.code) === 200) {
              this.actual_quantity = response.data.actual_quantity;
            } else {
              this.onToast(response.message);
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/anniversary/index/index.vue